import { axiosInstance, publicAxiosInstance } from './axiosInstance';
import { API_ROUTES } from "./apiRoutes";

const authService = {
  // Login API call
  login: async (email, password) => {
    try {
      const response = await publicAxiosInstance.post(API_ROUTES.AUTH.LOGIN, { email, password });
      const accessToken = response.data.data.access_token;
      // Store JWT token in localStorage
      localStorage.setItem('access_token', accessToken);

      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  // Magic Login API call (for email links)
  magicLogin: async (token) => {
    try {
      console.log('Magic login token:', token);
      const response = await publicAxiosInstance.get(API_ROUTES.AUTH.MAGIC_LOGIN, {
        params: { token }
      });
      const accessToken = response.data.data.access_token;
      // Store JWT token in localStorage
      localStorage.setItem('access_token', accessToken);

      return response.data;
    } catch (error) {
      console.error('Magic login error:', error);
      throw error;
    }
  },

  // Logout method to clear the token
  logout: async (isSessionExpired = false) => {
    try {
      // Only call logout API if it's not a session expiration
      if (!isSessionExpired) {
        await axiosInstance.post(API_ROUTES.AUTH.LOGOUT);
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Clear all local storage data
      localStorage.clear();
      window.location.href = '/login';
    }
  },

  // Change password method
  changePassword: async (oldPassword, newPassword, confirmPassword) => {
    try {
      const response = await axiosInstance.post(API_ROUTES.AUTH.CHANGE_PASSWORD, {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });

      // If the API returns a success false with a message, throw it as an error
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to change password');
      }

      return response.data;
    } catch (error) {
      // If it's an axios error with response data, throw the error message
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      // If it's our custom error (like token not found), throw it as is
      if (error.message === 'Authentication token not found') {
        throw error;
      }
      // For other errors, throw a generic message
      throw new Error('Failed to change password. Please try again.');
    }
  },

  // Get user profile method
  getUserProfile: async () => {
    try {
      const response = await axiosInstance.get(API_ROUTES.USER.PROFILE);

      // If the API returns a success false with a message, throw it as an error
      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to fetch profile');
      }

      return response.data;
    } catch (error) {
      console.error('Fetching profile error:', error);
      // If it's an axios error with response data, throw the error message
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      // If it's our custom error (like token not found), throw it as is
      if (error.message === 'Authentication token not found') {
        throw error;
      }
      // For other errors, throw a generic message
      throw new Error('Failed to fetch profile. Please try again.');
    }
  },

  sendResetPasswordLink: async (email) => {
    try {
      const response = await publicAxiosInstance.post(API_ROUTES.AUTH.SEND_RESET_PASSWORD_LINK, { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      const response = await publicAxiosInstance.post(API_ROUTES.AUTH.RESET_PASSWORD,
        { token, new_password: newPassword }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default authService;